module.exports = __webpack_public_path__ + "static/media/Client3AssociaLogo.c136d08e.png";